module.exports = __webpack_public_path__ + "static/hero-0ff463914de90a3ffb7d826988da2e7a.png";